import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerLicense } from '@syncfusion/ej2-base';
//import { licenses } from './environments/syncfusion-license';

//registerLicense(licenses.syncfusionLicenseKey);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
